import { AxiosPromise } from 'axios';
import { InboxFilter } from '../../types/InboxTypes';
import { libApiInstance } from '../axios';

export function requestSavedFilters(signal?: AbortSignal): AxiosPromise<InboxFilter[]> {
    return libApiInstance.get(`/config/filters/newrecent`, { signal });
}

export function requestCreateFilter(
    data: InboxFilter,
    signal?: AbortSignal,
): AxiosPromise<InboxFilter> {
    return libApiInstance.post(`/config/filters/newrecent`, data, { signal });
}

export function requestUpdateSavedFilter(
    data: InboxFilter,
    signal?: AbortSignal,
): AxiosPromise<InboxFilter> {
    return libApiInstance.put(`/config/filters/newrecent`, data, { signal });
}

export function requestDeleteSavedFilter(
    filterId: number,
    signal?: AbortSignal,
): AxiosPromise<boolean> {
    return libApiInstance.delete(`/config/filters/newrecent/${filterId}`);
}
